module.exports = __webpack_public_path__ + "img/4c76237e0b84dc7d69802b3898cb2e02.533280ec.png";